/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { PlatformLegalEntityDTO, PlatformLegalEntityResourceService } from '@well/platform-administration/company/shell';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  platformLegalEntityResourceService = inject(PlatformLegalEntityResourceService)

  getActivePlatformLegalEntityTemplate() : Observable<JsonApiResource<PlatformLegalEntityDTO, any>> {
    return this.platformLegalEntityResourceService.getActivePlatformLegalEntityTemplate();
  }
}
